module.exports = __webpack_public_path__ + "img/pressure_blue.c92b46ea.svg";